import * as React from 'react'
import { SVGProps } from 'react'

const LINKUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16.0005' cy='15.9994' r='15.9996' fill='white' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.9583 6.45854L15.9154 5.33319L17.8725 6.45854L23.2057 9.54102L25.1629 10.6664V21.3327L23.2057 22.4581L17.9215 25.5406L15.9643 26.6659L14.0072 25.5406L8.6251 22.4581L6.66797 21.3327V10.6664L8.6251 9.54102L13.9583 6.45854ZM10.583 12.9171V19.082L15.9162 22.1645L21.2494 19.082V12.9171L15.9162 9.83459L10.583 12.9171Z'
      fill='#2A5ADA'
    />
  </svg>
)

export default LINKUSD
